import React from 'react';
import styled from 'styled-components';
import { MoreHoriz, Delete, Archive } from '@material-ui/icons';
import { Tooltip } from "@material-ui/core"

const CustomIcon = styled(MoreHoriz)`
    &&& {
        fill: #fff;
        transition: opacity 300ms ease;
    }
`;
const CustomDelete = styled(Delete)`
    &&& {
        fill: #fff;
        height: 1rem;
    }
`;
const CustomArchive = styled(Archive)`
    &&& {
        fill: #fff;
        height: 1rem;
    }
`;


const ButtonsContainer = styled.div`
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: -100%;
    z-index: 1000;
    display: flex;
    transition: opacity 300ms ease-in;
`;

const Container = styled.div`
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;

    &:hover ${CustomIcon} {
        opacity: 0;
    }

    &:hover ${ButtonsContainer} {
        opacity: 1;
    }
`;


const Button = styled.button`
    background: transparent;
    border: 0;
    padding: 0;

    &:hover {
        cursor: pointer;
        background: transparent !important;
    }
`;


const Options = ({onDelete, onArchive}) => (
    <Container>
        <CustomIcon />
        <ButtonsContainer>
            <Tooltip title="Delete" placement="top">
                <Button onClick={onDelete}>
                    <CustomDelete />
                </Button>
            </Tooltip>
            <Tooltip title="Archive" placement="top">
                <Button onClick={onArchive}>
                    <CustomArchive />
                </Button>
            </Tooltip>
        </ButtonsContainer>
    </Container>
);

export default Options;
